<script setup lang="ts">
import StatBlock from "@/components/modules/Analytics/Charts/StatBlock.vue";
import DynamicByMonth from "@/components/modules/Analytics/Charts/DynamicByMonth.vue";
import RegionTop from "@/components/modules/Analytics/Charts/RegionTop.vue";
import {CasesSentToCourtAnalyticProps} from "@/types/analytics";

defineProps<CasesSentToCourtAnalyticProps>();
</script>

<template>
  <div class="params">
    <div class="params__wrapper">
      <StatBlock
        title="всего направлено прокурором в суд"
        :value="analyticData.totalData?.total_sent_to_court?.value"
        :percent="analyticData.totalData?.total_sent_to_court?.percent_to_previous"
        :is-appg="false"
        :is-main="true"
      />
      <StatBlock
        title="с постановлением о принудительном лечении (гл. 51 УПК РФ)"
        :value="analyticData.totalData?.with_medical_measures?.value"
        :percent="analyticData.totalData?.with_medical_measures?.percent_to_previous"
        :is-appg="false"
      />
      <StatBlock
        title="с ходатайством о воспитательных мерах к н/л (ст. 427 УПК РФ)"
        :value="analyticData.totalData?.juvenile?.value"
        :percent="analyticData.totalData?.juvenile?.percent_to_previous"
        :is-appg="false"
      />
      <StatBlock
        title="с ходатайством о назначении судебного штрафа (ст.446.2 УПК РФ)"
        :value="analyticData.totalData?.with_fine?.value"
        :percent="analyticData.totalData?.with_fine?.percent_to_previous"
        :is-appg="false"
      />
    </div>

    <DynamicByMonth
      :active-type="activeType"
      :selected-region="selectedRegion"
      :selected-district="selectedDistrict"
      :dynamic="analyticData.monthlyDynamic"
    />
    <template v-if="activeType !== 'region'">
      <RegionTop
        sort-order="desc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topDescending"
      />
      <RegionTop
        sort-order="asc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topAscending"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.params {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;

  &__wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    margin-top: auto;
  }
}
</style>